export default [
  {
    path: 'estico',
    name: 'estico.index',
    meta: {
      title: 'Meus Estico',
      auth: true,
      RedirectIfAuthenticated: false
    },
    component: () => import(/* webpackChunkName: "estico.index" */ '../views/estico/Index.vue')
  },
  {
    path: 'estico/novo',
    name: 'estico.create',
    meta: {
      title: 'Novo estico',
      auth: true,
      RedirectIfAuthenticated: false
    },
    component: () => import(/* webpackChunkName: "estico.create" */ '../views/estico/Create.vue')
  },
  {
    path: 'estico/:id',
    name: 'estico.show',
    meta: {
      title: 'Editando meu estico',
      auth: true,
      RedirectIfAuthenticated: false
    },
    component: () => import(/* webpackChunkName: "estico.show" */ '../views/estico/Show.vue')
  }
]
